/* global axios */
import ApiClient from '../ApiClient';

class SlotActionAutomationsAPI extends ApiClient {
  constructor() {
    super('omni/slots_config', { accountScoped: true });
  }

  // Note: do NOT name this `baseUrl` — the parent `ApiClient` has a method
  // `baseUrl()` that is called from its `url` getter. Overriding it with a
  // signature that reads `this.url` causes infinite recursion (stack overflow).
  slotUrl(slotId) {
    return `${this.url}/${slotId}/action_automations`;
  }

  list(slotId) {
    return axios.get(this.slotUrl(slotId));
  }

  show(slotId, id) {
    return axios.get(`${this.slotUrl(slotId)}/${id}`);
  }

  create(slotId, automation) {
    return axios.post(this.slotUrl(slotId), { automation });
  }

  update(slotId, id, automation) {
    return axios.patch(`${this.slotUrl(slotId)}/${id}`, { automation });
  }

  delete(slotId, id) {
    return axios.delete(`${this.slotUrl(slotId)}/${id}`);
  }

  toggle(slotId, id) {
    return axios.patch(`${this.slotUrl(slotId)}/${id}/toggle`);
  }

  reorder(slotId, order) {
    return axios.post(`${this.slotUrl(slotId)}/reorder`, { order });
  }

  testConditions(slotId, { conditions, sampleResponse, conversationId }) {
    return axios.post(`${this.slotUrl(slotId)}/test_conditions`, {
      conditions,
      sample_response: sampleResponse,
      conversation_id: conversationId,
    });
  }

  simulate(slotId, { sampleResponse, conversationId } = {}) {
    return axios.post(`${this.slotUrl(slotId)}/simulate`, {
      sample_response: sampleResponse,
      conversation_id: conversationId,
    });
  }

  export(slotId) {
    return axios.get(`${this.slotUrl(slotId)}/export`);
  }

  import(slotId, { automations, replace = false } = {}) {
    return axios.post(`${this.slotUrl(slotId)}/import`, {
      automations,
      replace,
    });
  }
}

export default new SlotActionAutomationsAPI();
